module.exports = __webpack_public_path__ + "static/NanumSquareEB-9ee5085e37e8ac9dd4aa44813d9b924a.ttf";